// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/defaultPage/not-allowed.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotAuthorized_container__DCMMQ {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.NotAuthorized_notFoundImg__\\+W8A4 {
  height: 80%;
  width: 100%;
  object-position: center;
  offset-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.NotAuthorized_backBtnContainer__LSh4\\+ {
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.NotAuthorized_backBtn__Ikcma {
  width: 250px;
  height: 50px;
  background-color: transparent;
  border-radius: 10px;
  border: 3px solid #f0190a;
  outline: none;
  cursor: pointer;
  color: #f0190a;
  font-size: 21px;
  font-weight: 600;
  transition: all 0.4s ease-out;
}
.NotAuthorized_backBtn__Ikcma:hover {
  background: #f0190a;
  color: #fff;
}
@media all and (max-width: 450px) {
  .NotAuthorized_backBtnContainer__LSh4\\+ {
    width: 100%;
    justify-content: center;
  }
  .NotAuthorized_backBtn__Ikcma {
    width: 50%;
    height: 30px;
    font-size: 17px;
    font-weight: 500;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/NotAuthorized/NotAuthorized.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,yDAAoE;AACtE;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".container {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n.notFoundImg {\r\n  height: 80%;\r\n  width: 100%;\r\n  object-position: center;\r\n  offset-position: center;\r\n  background-position: center;\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-image: url(\"../../../images/defaultPage/not-allowed.jpg\");\r\n}\r\n.backBtnContainer {\r\n  height: 20%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.backBtn {\r\n  width: 250px;\r\n  height: 50px;\r\n  background-color: transparent;\r\n  border-radius: 10px;\r\n  border: 3px solid #f0190a;\r\n  outline: none;\r\n  cursor: pointer;\r\n  color: #f0190a;\r\n  font-size: 21px;\r\n  font-weight: 600;\r\n  transition: all 0.4s ease-out;\r\n}\r\n.backBtn:hover {\r\n  background: #f0190a;\r\n  color: #fff;\r\n}\r\n@media all and (max-width: 450px) {\r\n  .backBtnContainer {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n  .backBtn {\r\n    width: 50%;\r\n    height: 30px;\r\n    font-size: 17px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NotAuthorized_container__DCMMQ`,
	"notFoundImg": `NotAuthorized_notFoundImg__+W8A4`,
	"backBtnContainer": `NotAuthorized_backBtnContainer__LSh4+`,
	"backBtn": `NotAuthorized_backBtn__Ikcma`
};
export default ___CSS_LOADER_EXPORT___;
